import React, { useEffect } from 'react';
import { SeoBar } from '../components/SeoBar';
import { Header } from '../components/Header';
import { Footer } from '../components/Footer';
import { HeroSection } from './selling-used-edm/HeroSection';
import { IntroSection } from './selling-used-edm/IntroSection';
import { ContactFormSection } from './selling-used-edm/ContactFormSection';
export function SellingUsedEDMPage() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return <div className="min-h-screen w-full bg-white flex flex-col" data-id="element-3753">
      <SeoBar data-id="element-3754" />
      <Header data-id="element-3755" />
      <main className="flex-grow" data-id="element-3756">
        <div className="w-full bg-gray-50 pb-20" data-id="element-3757">
          <HeroSection data-id="element-3758" />
          <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-12 md:py-16" data-id="element-3759">
            <IntroSection data-id="element-3760" />
            <ContactFormSection data-id="element-3761" />
          </div>
        </div>
      </main>
      <Footer data-id="element-3762" />
    </div>;
}